import { render, staticRenderFns } from "./TransitionToAuto.vue?vue&type=template&id=066d11c8&scoped=true"
import script from "./TransitionToAuto.vue?vue&type=script&lang=js"
export * from "./TransitionToAuto.vue?vue&type=script&lang=js"
import style0 from "./TransitionToAuto.vue?vue&type=style&index=0&id=066d11c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d11c8",
  null
  
)

export default component.exports